<div class="pad-top" *ngIf="project() as project">
  <fw-grid>
    <fw-grid-item [cols]="9" variant="page-shaded">
      <project-statistics [loading]="project === undefined" [statistics]="project?.stats?.number_of"></project-statistics>
      <div class="card description-card">
        <h1 class="font-card-header has-button">
          Description
          <span *ngIf="canEditDescription()">
            <span
              class="markdown-hint">Markdown Supported</span>
            <fw-button *ngIf="!editingDescription" variant="outline" color="primary"
              (click)="editingDescription = true" leftIcon="edit" test-id="edit-description-button">
              Edit
            </fw-button>
          </span>
        </h1>
        <div class="markdown-container">
          <ng-container *ngIf="project; else loadingDescription">
            <ng-container *ngIf="!editingDescription; else editDescription">
              <p *ngIf="descriptionHtml" [innerHTML]="descriptionHtml"></p>
              <div *ngIf="!descriptionHtml" class="empty-description">
                <fw-icon class="bright-blue md">edit</fw-icon>
                <p>This project does not have a description.</p>
                <fw-button *ngIf="canEditDescription()" (click)="editingDescription = true" test-id="add-description-button">
                  Add Description
                </fw-button>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #loadingDescription>
            <fw-loading></fw-loading>
          </ng-template>
          <ng-template #editDescription>
            <textarea name="description" data-id="project-description-content" test-id="project-description-content"
              [formControl]="projectDescription"></textarea>
            <fw-grid *ngIf="project">
              <fw-grid-item [cols]="4">
                <p class="text-muted">
                  <small>{{"{{0}} of {{1}} characters" | interpolate:projectDescription.value?.length||0:10000 }}</small>
                </p>
              </fw-grid-item>
              <fw-grid-item [cols]="8">
                <fw-button variant="outline" color="slate" (click)="editingDescription = false" test-id="cancel-description-button">
                  Cancel
                </fw-button>
                <fw-button color="primary" (click)="saveProjectDescription(project)"
                  [disabled]="projectDescription.invalid" test-id="save-description-button">
                  Save
                </fw-button>
              </fw-grid-item>
            </fw-grid>
          </ng-template>
        </div>
      </div>
    </fw-grid-item>
    <fw-grid-item [cols]="3" variant="page-shaded">
      @if (ohifEnabled) {
        <div class="card description-right-card">
          <h1 class="font-card-header">Viewer</h1>
          <fw-button [fullWidth]="true" (click)="viewProjectStudies()" test-id="viewer-study-list-button">
            Viewer Study List
          </fw-button>
        </div>
      }
      <div class="card description-right-card">
        <h1 class="font-card-header">Quick Tip</h1>
        <p>The project description can be used to provide users with context for the data in the project. Helpful information includes a description of the types of data collected, the subject population, and the research question the project addresses.</p>
        <p>A project's description is visible to all users with access to the project.</p>
      </div>
    </fw-grid-item>
  </fw-grid>
</div>
